"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
const flatbuffers = require("flatbuffers");
const MosaicLevyBuffer_1 = require("./MosaicLevyBuffer");
class ModifyMosaicLevyTransactionBuffer {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsModifyMosaicLevyTransactionBuffer(bb, obj) {
        return (obj || new ModifyMosaicLevyTransactionBuffer()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsModifyMosaicLevyTransactionBuffer(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ModifyMosaicLevyTransactionBuffer()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    size() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    signature(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    signatureLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    signatureArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    signer(index) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    signerLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    signerArray() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    version() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    maxFee(index) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    maxFeeLength() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    maxFeeArray() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    deadline(index) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    deadlineLength() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    deadlineArray() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    mosaicId(index) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    mosaicIdLength() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    mosaicIdArray() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    levy(obj) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? (obj || new MosaicLevyBuffer_1.MosaicLevy()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startModifyMosaicLevyTransactionBuffer(builder) {
        builder.startObject(9);
    }
    static addSize(builder, size) {
        builder.addFieldInt32(0, size, 0);
    }
    static addSignature(builder, signatureOffset) {
        builder.addFieldOffset(1, signatureOffset, 0);
    }
    static createSignatureVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startSignatureVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addSigner(builder, signerOffset) {
        builder.addFieldOffset(2, signerOffset, 0);
    }
    static createSignerVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startSignerVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addVersion(builder, version) {
        builder.addFieldInt32(3, version, 0);
    }
    static addType(builder, type) {
        builder.addFieldInt16(4, type, 0);
    }
    static addMaxFee(builder, maxFeeOffset) {
        builder.addFieldOffset(5, maxFeeOffset, 0);
    }
    static createMaxFeeVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startMaxFeeVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addDeadline(builder, deadlineOffset) {
        builder.addFieldOffset(6, deadlineOffset, 0);
    }
    static createDeadlineVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startDeadlineVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addMosaicId(builder, mosaicIdOffset) {
        builder.addFieldOffset(7, mosaicIdOffset, 0);
    }
    static createMosaicIdVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startMosaicIdVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static createLevyVector(builder, type, recipientOffset, mosaicIdOffset, feeOffset) {
        return MosaicLevyBuffer_1.MosaicLevy.createMosaicLevy(builder, type, recipientOffset, mosaicIdOffset, feeOffset);
    }
    ;
    static addLevy(builder, levyOffset) {
        builder.addFieldOffset(8, levyOffset, 0);
    }
    static endModifyMosaicLevyTransactionBuffer(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static finishModifyMosaicLevyTransactionBufferBuffer(builder, offset) {
        builder.finish(offset);
    }
    static finishSizePrefixedModifyMosaicLevyTransactionBufferBuffer(builder, offset) {
        builder.finish(offset, undefined, true);
    }
}
exports.ModifyMosaicLevyTransactionBuffer = ModifyMosaicLevyTransactionBuffer;
//# sourceMappingURL=ModifyMosaicLevyTransactionBuffer.js.map